import { api } from 'utility';
import {
  getReportFinancialBranchesExport,
  getReportFinancialDigitalExport,
  getReportFinancialGuildsExport,
  getReportFinancialImprestExport,
  getReportFinancialDelegationExport,
  getReportFinancialDelegationListExport,
  getReportFinancialVoucherExport,
  getReportFinancialInvoiceExport,
  getReportFinancialInvoiceCreditorExport,
  getReportFinancialSettlementWalletExport,
  getReportFinancialSettlementGuildExport,
  getReportImprestListExport,
  getReportReportSummaryExport,
  getImprestDepositReport,
  getFeature
} from 'URLs';

export function getFeatureList() {
  return api.get(getFeature()).then((res) => res.data);
}

export function getTransactionSettlementGuildFormat(params, format) {
  return api.get(getReportFinancialSettlementGuildExport(format), { params }).then((res) => res.data);
}
export function getTransactionSettlementWalletFormat(params, format) {
  return api.get(getReportFinancialSettlementWalletExport(format), { params }).then((res) => res.data);
}
export function getTransactionImprestListFormat(params) {
  return api.get(getReportImprestListExport(), { params }).then((res) => res.data);
}
export function getTransactionInvoiceCreditorFormat(params, format) {
  return api.get(getReportFinancialInvoiceExport(format), { params }).then((res) => res.data);
}
export function getTransactionReportSummaryFormat(params, format) {
  return api.get(getReportReportSummaryExport(format), { params }).then((res) => res.data);
}
export function getTransactionInvoiceFormat(params, format) {
  return api.get(getReportFinancialInvoiceCreditorExport(format), { params }).then((res) => res.data);
}
export function getTransactionBranchFormat(params , format) {
  return api.get(getReportFinancialBranchesExport(format), { params }).then((res) => res.data);
}

export function getTransactionImprestFormat(params , format) {
  return api.get(getReportFinancialImprestExport(format), { params }).then((res) => res.data);
}

export function getTransactionWalletFormat(params, format) {
  return api.get(getReportFinancialDigitalExport(format), { params }).then((res) => res.data);
}

export function getTransactionDelegationFormat(params , format) {
  return api.get(getReportFinancialDelegationExport(format), { params }).then((res) => res.data);
}
export function getTransactionDelegationListFormat(params , format) {
  return api.get(getReportFinancialDelegationListExport(format), { params }).then((res) => res.data);
}
export function getTransactionVoucherFormat(params , format) {
  return api.get(getReportFinancialVoucherExport(format), { params }).then((res) => res.data);
}

export function getTransactionGuildFormat(params , format) {
  return api.get(getReportFinancialGuildsExport(format), { params }).then((res) => res.data);
}
export function getImprestDepositReportFormat(params, format) {
  return api.get(getImprestDepositReport(format), { params }).then((res) => res.data);
}
export default {
  getTransactionWalletFormat,
  getTransactionGuildFormat,
  getTransactionBranchFormat,
  getTransactionImprestFormat,
  getTransactionDelegationFormat,
  getTransactionDelegationListFormat,
  getTransactionVoucherFormat,
  getTransactionInvoiceFormat,
  getTransactionInvoiceCreditorFormat,
  getTransactionSettlementWalletFormat,
  getTransactionSettlementGuildFormat,
  getTransactionImprestListFormat,
  getImprestDepositReportFormat,
  getFeatureList
};